import React from "react";

type PaddockTimeLegendProps = {
  maxOcupacao: number;
  maxDescanso: number;
};

export function PaddockTimeLegend({ maxOcupacao, maxDescanso }: PaddockTimeLegendProps) {
  const formatNumber = (num: number) => {
    return num % 1 === 0 ? num.toString() : num.toFixed(2);
  };

  return (
    <section className="capacitybvroute__barnumber--container">
      {maxOcupacao !== 0 && (
        <div>
          <strong className="capacitybvroute__barnumber--title">Dias de ocupação</strong>
          <div className="paddocktime__barnumber--bar1" />
          <div className="paddocktime__barnumber--containerlegend">
            <span>0</span>
            <span>{formatNumber(Number(maxOcupacao))}</span>
          </div>
        </div>
      )}
      <br />
      {maxDescanso !== 0 && (
        <div>
          <strong className="capacitybvroute__barnumber--title">Dias de descanso</strong>
          <div className="paddocktime__barnumber--bar2" />
          <div className="paddocktime__barnumber--containerlegend">
            <span>0</span>
            <span>{formatNumber(Number(maxDescanso))}</span>
          </div>
        </div>
      )}
    </section>
  );
}
